import { alpha, Box, CircularProgress, Menu, MenuItem, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import { useState } from "react";
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import SyncAltOutlinedIcon from '@mui/icons-material/SyncAltOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ActiveButton from "../buttons/active_button";

export default function UserItemWidget(
    { user, currentUserRole, ownerTransform, manageProjects, changeRole, removeUser, isLoading }) {
    const { mode } = useColorScheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const currentMode = mode || "system";
    const role = user.role || "guest";
    const getRoleButton = () => {
        if (user.role == "owner") {
            return <ActiveButton
                text={"Owner"}
                />
        } else if (user.role === "team") {
            return <Box
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.medium,
                        fontSize: Constants.Styles.fontSize.xs,
                        lineHeight: Constants.Styles.lineHeight.xs,
                        color: Constants.Colors[currentMode].foreground,
                        backgroundColor: Constants.Colors[currentMode].secondary,
                        border: "none",
                        borderRadius: "0.25rem",
                        padding: "0rem 0.5rem",
                    }}
                >
                    Team
                </Box>
        } else if (user.role === "guest") {
            return <Box
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.medium,
                        fontSize: Constants.Styles.fontSize.xs,
                        lineHeight: Constants.Styles.lineHeight.xs,
                        color: Constants.Colors[currentMode].mutedForeground,
                        backgroundColor: Constants.Colors[currentMode].secondary,
                        border: "none",
                        borderRadius: "0.25rem",
                        padding: "0rem 0.5rem",
                    }}
                >
                    Guest
                </Box>
        } else {
            return <Box></Box>
        }
    }
    return (
        <Stack key={user.user_id}
            direction={{
                xs: "column",
                sm: "row",
            }}
            alignItems={{
                xs: "start",
                sm: "center",
            }}
            justifyContent={"space-between"}
            sx={{
                padding: {
                    xs: `calc(${Constants.Styles.spacing} * 2)`,
                    sm: `calc(${Constants.Styles.spacing} * 4)`,
                },
                backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.3),
                border: `1px solid ${Constants.Colors[currentMode].border}`,
                borderRadius: `calc(${Constants.Styles.radius.base} - 2px)`,
            }}
            spacing={1}
        >

            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{
                    // width: "100%",
                    // marginInline: "auto",
                }}
                spacing={"1.125rem"}
            >
                <Box
                    sx={{
                        borderRadius: "50%",
                        height: 40,
                        width: 40,
                        backgroundColor: alpha(Constants.Colors[currentMode].accent, 0.3),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography
                        sx={{
                            color: Constants.Colors[currentMode].accent,
                            fontWeight: Constants.Styles.fontWeight.medium,
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                        }}
                    >
                        {user.user_id?.substring(0, 2).toUpperCase()}
                    </Typography>
                </Box>
                <Typography sx={{
                    fontWeight: Constants.Styles.fontWeight.medium,
                    fontSize: Constants.Styles.fontSize.sm,
                    lineHeight: Constants.Styles.lineHeight.sm,
                }}>
                    {user.user_id}
                </Typography>
            </Stack>
            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"start"}
                sx={{
                    // width: "100%",
                    // marginInline: "auto",
                }}
                spacing={"0.5rem"}
            >
                {getRoleButton()}
                {isLoading && <CircularProgress size={20} />}
                {!isLoading && currentUserRole !== "guest" && <Box
                    sx={{
                        borderRadius: "0.25rem",
                        height: 30,
                        width: 30,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        color: Constants.Colors[currentMode].mutedForeground,
                        "&:hover": {
                            backgroundColor: alpha(Constants.Colors[currentMode].accent, 1),
                            color: Constants.Colors[currentMode].accentForeground,
                        }
                    }}
                >
                    <MoreHorizOutlinedIcon onClick={handleClick} sx={{
                        fontSize: Constants.Styles.fontSize.lg,
                    }} />
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        slotProps={{
                            list: {
                                'aria-labelledby': 'basic-button',
                            },
                        }}
                        sx={{
                            mt: "1.0rem",
                        }}
                    >
                        {role === "owner" && currentUserRole === "owner" && <MenuItem onClick={() => {
                            ownerTransform(user);
                            handleClose();
                        }}>
                            <Stack
                                direction={"row"}
                                alignItems={"center"}
                                justifyContent={"start"}
                                spacing={"0.5rem"}
                            >
                                <SyncAltOutlinedIcon sx={{
                                    fontSize: Constants.Styles.fontSize.lg,
                                    color: Constants.Colors[currentMode].mutedForeground,
                                }} />
                                <Typography
                                    sx={{
                                        fontWeight: Constants.Styles.fontWeight.normal,
                                        fontSize: Constants.Styles.fontSize.sm,
                                        lineHeight: Constants.Styles.lineHeight.sm,
                                    }}
                                >
                                    Transfer ownership
                                </Typography>
                            </Stack>
                        </MenuItem>}
                        {role === "guest" && <MenuItem onClick={() => {
                            manageProjects(user);
                            handleClose();
                        }}>
                            <Stack
                                direction={"row"}
                                alignItems={"center"}
                                justifyContent={"start"}
                                spacing={"0.5rem"}
                            >
                                <SourceOutlinedIcon sx={{
                                    fontSize: Constants.Styles.fontSize.lg,
                                    color: Constants.Colors[currentMode].mutedForeground,
                                }} />
                                <Typography
                                    sx={{
                                        fontWeight: Constants.Styles.fontWeight.normal,
                                        fontSize: Constants.Styles.fontSize.sm,
                                        lineHeight: Constants.Styles.lineHeight.sm,
                                    }}
                                >
                                    Projects
                                </Typography>
                            </Stack>
                        </MenuItem>}
                        {role !== "owner" && <MenuItem onClick={() => {
                            changeRole(user);
                            handleClose();
                        }}>
                            <Stack
                                direction={"row"}
                                alignItems={"center"}
                                justifyContent={"start"}
                                spacing={"0.5rem"}
                            >
                                <ShieldOutlinedIcon sx={{
                                    fontSize: Constants.Styles.fontSize.lg,
                                    color: Constants.Colors[currentMode].mutedForeground,
                                }} />
                                <Typography
                                    sx={{
                                        fontWeight: Constants.Styles.fontWeight.normal,
                                        fontSize: Constants.Styles.fontSize.sm,
                                        lineHeight: Constants.Styles.lineHeight.sm,
                                    }}
                                >
                                    Change Role
                                </Typography>
                            </Stack>
                        </MenuItem>}
                        {role !== "owner" && <MenuItem onClick={() => {
                            removeUser(user);
                            handleClose();
                        }}>
                            <Stack
                                direction={"row"}
                                alignItems={"center"}
                                justifyContent={"start"}
                                spacing={"0.5rem"}
                            >
                                <DeleteForeverOutlinedIcon sx={{
                                    fontSize: Constants.Styles.fontSize.lg,
                                    color: Constants.Colors[currentMode].mutedForeground,
                                }} />
                                <Typography
                                    sx={{
                                        fontWeight: Constants.Styles.fontWeight.normal,
                                        fontSize: Constants.Styles.fontSize.sm,
                                        lineHeight: Constants.Styles.lineHeight.sm,
                                        color: Constants.Colors[currentMode].destructive,
                                    }}
                                >
                                    Remove
                                </Typography>
                            </Stack>
                        </MenuItem>}
                    </Menu>
                </Box>}
            </Stack>
        </Stack>
    );
}